import React from 'react';
import { Button } from 'react-bootstrap-5';

export type AddTagButtonProps = {
  buttonClasses?: string;
  extraLabel?: string;
  variant?: string;
  iconLeft?: React.JSX.Element;
  iconRight?: React.JSX.Element;
}

export default function AddTagButton({ buttonClasses, extraLabel, variant, iconLeft, iconRight }: AddTagButtonProps) {
  return (
    <Button className={buttonClasses} variant={variant || 'outline-primary'}>
      {iconLeft}
      Add Tag {extraLabel}
      {iconRight}
    </Button>
  );
}
